// extracted by mini-css-extract-plugin
module.exports = {"image_wrap":"styles_image_wrap__2DgRA","title":"styles_title__1uZyo","text":"styles_text__2uTYQ"};